import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import Container from '@ep/components/Container';
import { Label } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_Post } from '@ep/types/gatsbyTypes';
import useScroll from '@ep/utils/useScroll';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Pagination from '@mui/material/Pagination';
import React, { useEffect } from 'react';
import PostCard from '../PostCarouselModule/Post/PostCard';
//import chunkPosts from '@ep/utils/chunkPosts';

export interface postsProps {
  posts: Gcms_Post[];
}

const GridContainer = styled.div`
  margin: 1rem 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem 1rem;
  > div {
    width: 95%;
    margin: 0 auto !important;
    &:hover {
      transition: 0.25s;
      box-shadow: 8px 8px 15px ${theme.colors.darkGray};
      transform: translate(-6px, -6px);
    }
  }
  ${theme.mediaQueries.tablet} {
    grid-template-columns: 1fr 1fr;
  }
  ${theme.mediaQueries.mobile} {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledPagination = styled(Pagination)`
  li {
    margin: 3rem 0;
  }
  li:last-child {
    margin-bottom: 3rem;
  }
`;

const chunkPosts = (arr, size) =>
  arr.reduce(
    (acc, e, i) => (
      i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc
    ),
    [],
  );

const PostGridModule = ({ posts }: postsProps) => {
  const [page, setPage] = React.useState(1);

  useEffect(() => { 
    setPage(1)
  }, [posts]);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    const gridRef = document.getElementById('gridTop');
    if (gridRef) {
      gridRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    setPage(value);
  };


  const chunkedPosts = chunkPosts(posts, 9);

  return (
    <>
      <GridContainer>
        {chunkedPosts[page - 1]?.map(post => (
          <PostCard key={`Post_grid__${post.id}`} post={post} />
        ))}
      </GridContainer>
      {chunkedPosts.length > 1 && (
        <PaginationContainer>
          <StyledPagination
            count={chunkedPosts.length}
            page={page}
            onChange={handleChange}
          />
        </PaginationContainer>
      )}
    </>
  );
};

export default PostGridModule;
